export default class FavoritesExecutes {
  constructor(el) {
    this.el = el;
    this.favAction = this.el.getAttribute('data-action');
    this.favExecType = this.el.getAttribute('data-exec-type');
    this.messageContainer = $('.js-message-form-alert');
    this.favcounter = $('#favcounter');

    this.init();
  }

  init() {
    if (this.favExecType === 'button' && this.favAction === 'delfav') {
      this.el.addEventListener('click', () => {
        const elements = document.querySelectorAll(
          'input[id^="checkFav_"]:checked'
        );
        let checkedIDs = [];
        // Reset array if not empty.
        if (checkedIDs.length > 0) {
          checkedIDs = [];
        }
        Array.prototype.map.call(elements, element => {
          checkedIDs.push(element.value);
        });
        const data = {
          del: 'true',
          really_del: 'true',
          ajaxed: 'true',
          id: checkedIDs
        };
        // Send data to server
        $.post(
          '/ajax.php',
          {
            json: true,
            id: checkedIDs,
            mode: 'delfav',
            data
          },
          respond => {
            this.messageContainer
              .fadeIn()
              .delay(500)
              .fadeOut('slow');
            // Wurden Favoriten gelöscht?
            if (typeof respond.deleted !== 'undefined') {
              $.each(respond.deleted, (idx, val) => {
                $(`input[id^="checkFav_${val}"]`)
                  .parents('ul')
                  .slideUp()
                  .remove();
                $(`input[id^="checkFav_${val}"]`)
                  .parents('.profile-one')
                  .slideUp()
                  .remove();
              });
              // Anzahl der restlichen Favoriten berechnen und Counter updaten.
              const fCount = $('input[id^="checkFav_"]').length;
              $('#favcounter').text(fCount);
              // Keine mehr Übrig?
              if (!fCount || fCount < 0) {
                $('#favsFound, #buttons').fadeOut(() => {
                  $('#noFavs').fadeIn();
                });
              }
              this.messageContainer.find('p').html(respond.message);
            }
          },
          'json'
        );
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/favorites.js